import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";



export default function () {
  const videoButtons = document.querySelectorAll('.video-btn');

  videoButtons.forEach(videoBtn => {
    videoBtn.addEventListener('click', toggleVideo);
  })

  function toggleVideo() {
    const btn = this;
    const btnParentSection = btn.closest('.video-section');
    const videoMP4 = btnParentSection.querySelector('video');
    const btnSpan = btn.querySelector('.video-btn__text span:first-child');

    // Hide video -> reset to 0 seconds -> show video
    if (btn.classList.contains('repeat')) {
      gsap.timeline()
        .to(videoMP4, {
          opacity: 0,
          duration: 0.4,
        })

        .call(() => {
          videoMP4.currentTime = 0;
        })

        .to(videoMP4, {
          opacity: 1,
          duration: 0.5,
        }, '>0.2')

        // Play video and hide btn
        .to(btn, {
          opacity: 0,
          pointerEvents: 'none',
        })
        .call(() => {
          videoMP4.play();
        })

    } else {
      // Play video and hide btn
      gsap.to(btn, {
        opacity: 0,
        pointerEvents: 'none',
      })
        .then(() => videoMP4.play())
    }


    // Pause video when user click. Show Play button
    videoMP4.addEventListener('click', () => {
      videoMP4.pause();
      gsap.to(btn, {
        opacity: 1,
        pointerEvents: 'all',
      });
      btnSpan.innerText = btn.getAttribute('text-play');

    });

    // When video is end. Show repeat button
    videoMP4.addEventListener('ended', () => {
      videoMP4.pause();

      btnSpan.innerText = btn.getAttribute('text-repeat');
      btn.classList.add('repeat');

      gsap.to(btn, {
        opacity: 1,
        pointerEvents: 'all',
      })
    })
  }
}